import { render, staticRenderFns } from "./ApprovalStatusPage.vue?vue&type=template&id=2a72bbd2"
import script from "./ApprovalStatusPage.vue?vue&type=script&lang=ts"
export * from "./ApprovalStatusPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a72bbd2')) {
      api.createRecord('2a72bbd2', component.options)
    } else {
      api.reload('2a72bbd2', component.options)
    }
    module.hot.accept("./ApprovalStatusPage.vue?vue&type=template&id=2a72bbd2", function () {
      api.rerender('2a72bbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/approval-status/ApprovalStatusPage.vue"
export default component.exports